import { Component, Vue } from 'vue-property-decorator';
import DefaultDialog from '@/components/dialog/DefaultDialog.vue';
import StorageDataTable from '@/components/StorageDataTable/StorageDataTable.vue';

@Component<StorageDialog>({
  components: {
    DefaultDialog,
    StorageDataTable,
  },
})
export default class StorageDialog extends Vue {
  // File structure for Typescript files in your Vue project
  // https://tutorials.atabix.com/frontend/typscript_file_structure/

  // #region @Props

  // #endregion

  // #region @Refs
  // #endregion

  // #region Class properties
  // #endregion

  // #region Lifecycle Hooks / Init
  // #endregion

  // #region Class methods
  protected close(): void {
    this.$emit('input', false);
  }
  // #endregion

  // #region Async methods
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
